import { useCallback, useEffect, useState } from 'react';

export const useCurrentLocation = () => {
  const [currentLocation, setCurrentLocation] =
    useState<GeolocationPosition | null>(null);

  const handlerLocation = useCallback(() => {
    if (!navigator.geolocation) {
      console.error('Geolocation is not supported by this browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCurrentLocation(position);
      },
      (error) => {
        console.error('Error getting current position:', error);
      },
    );
  }, []);

  useEffect(() => {
    handlerLocation();
  }, [handlerLocation]);

  return { currentLocation, handlerLocation };
};
